import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';

export type BUTTON_TYPE = 'PRIMARY' | 'OUTLINE' | 'TEXT';
export type COLOR_TYPE = 'primary' | 'danger';

interface ButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: ReactNode | string;
  theme: BUTTON_TYPE;
  color?: COLOR_TYPE;
}

interface ThemeListType {
  [key: string]: string;
}

const Button = ({
  children,
  theme,
  color = 'primary',
  ...props
}: ButtonProps) => {
  const THEME_LIST: ThemeListType = {
    PRIMARY: `bg-primary-light-blue rounded-lg text-white text-base font-semibold py-2.5 px-[42px] cursor-pointer hover:opacity-[90%] transition-all`,
    OUTLINE: `border-black border rounded-lg text-black text-base py-2.5 px-[42px] cursor-pointer hover:opacity-[90%] transition-all`,
    TEXT: `text-primary-light-blue text-base font-semibold py-2.5 px-[42px] cursor-pointer hover:opacity-[90%] transition-all`,
  };

  return (
    <button
      {...props}
      className={`${THEME_LIST[theme]} ${props?.className ?? ''} `}
    >
      {children}
    </button>
  );
};

export default Button;
